export const TASK_EXTENDED_VIEW = {'name': 'extended view', 'value': 'extended'};
export const TASK_SIMPLE_VIEW = {'name': 'simple view', 'value': 'simple'};

export const TASKS_VIEWS_LIST = [
    TASK_EXTENDED_VIEW,
    TASK_SIMPLE_VIEW
]
